
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import MenuItem from "../../../models/menuItem";
  @Component({
    name: "base-menu-item"
  })
  export default class BaseMenuItemComponent extends Vue {
    @Prop({default: null}) menuItem: MenuItem;
  }
